<template>
  <div class="tag-age" v-if="component">
    <component :is="component" v-if="component" key="ageTag" />
  </div>
</template>
<script>
export default {
  name: 'AgeTag',
  props: ['ageCode', 'contentType'],
  data () {
    return {
      component: null
    }
  },
  computed: {
    loader () {
      let ageTagIcon = ''
      if (this.contentType === 'mypooq') {
        ageTagIcon = this.ageCode === '18' || this.ageCode === '19' || this.ageCode === '21' ? 'ic_tag_6_5' : ''
      } else if (this.contentType === 'mypooq_vod') {
        ageTagIcon = this.ageCode === '18' || this.ageCode === '19' || this.ageCode === '21' ? 'ic_tag_6_4' : ''
      } else {
        switch (this.ageCode) {
          case '0':
            if (this.contentType === 'movie') {
              ageTagIcon = 'ic_tag_6_1'
            }
            break
          case '12':
            ageTagIcon = 'ic_tag_6_2'
            break
          case '15':
            ageTagIcon = 'ic_tag_6_3'
            break
          case '18':
          case '19':
            ageTagIcon = this.contentType === 'movie' ? 'ic_tag_6_5' : 'ic_tag_6_4'
            break
          case '21':
          case 'adult':
            ageTagIcon = 'ic_tag_6_5'
            break
        }
      }
      return () => import(`@/assets/svg/common/tags/age/${ageTagIcon}.svg`)
    }
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        console.log('error')
      })
  }
}
</script>
